import { ActionType } from './action';

function jokeReducer(joke = null, action = {}) {
  switch (action.type) {
    case ActionType.RECEIVE_JOKE:
      return action.payload.joke;
    default:
      return joke;
  }
}

export default jokeReducer;
